export default function EmptyState({ icon: Icon, title, batch, description, testId }) {
  return (
    <div
      data-testid={testId || "journey-empty-state"}
      className="mx-auto mt-8 max-w-xl rounded-md border border-dashed border-white/10 bg-white/[0.02] px-8 py-14 text-center"
    >
      {Icon ? (
        <div className="mx-auto mb-5 inline-flex h-10 w-10 items-center justify-center rounded border border-white/10 text-emerald-400/80">
          <Icon className="h-5 w-5" />
        </div>
      ) : null}
      <h2 className="text-base font-semibold text-zinc-100">{title}</h2>
      {batch ? (
        <p className="mt-1 text-[11px] uppercase tracking-[0.18em] text-emerald-400/70">
          {batch}
        </p>
      ) : null}
      {description ? (
        <p className="mt-3 text-sm leading-relaxed text-zinc-400">
          {description}
        </p>
      ) : null}
    </div>
  );
}
